export const graphHopStyles = [
  {
    selector: "node[hop='0']",
    style: {
      width: '132px',
      height: '132px',
      "background-color": "#E74C3C",
      "border-color": "#C0392B",
      "border-width": "4px",
      "font-size": "19px",
      "z-index": "100"
    }
  },
  {
    selector: "node[hop='1']",
    style: {
      width: '102px',
      height: '102px',
      "background-color": "#3498DB",
      "background-opacity": 1,
      "border-color": "#2980B9",
      "font-size": "16px",
      "z-index": "50"
    }
  },
  {
    selector: "node[hop='2']",
    style: {
      width: '80px',
      height: '80px',
      "background-color": "#9B59B6",
      "background-opacity": 0.85,
      "border-color": "#8E44AD",
      "font-size": "14px",
      "z-index": "30"
    }
  },
  {
    selector: "node[hop >= 3]",
    style: {
      width: '52px',
      height: '52px',
      "background-color": "#95A5A6",
      "background-opacity": 0.6,
      "border-color": "#7F8C8D",
      "border-width": "1px",
      "font-size": "12px",
      "z-index": "5"
    }
  },
  {
    selector: "node[hop >= 3]:selected",
    style: {
      "font-size": "13px"
    }
  },
];
